// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3XE4R","header":"PatientQuestionnaire_header__1vhFw","info":"PatientQuestionnaire_info__2S_B4"};